var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityAccessibleChangingRoom = function SvgAccessibilityAccessibleChangingRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M26.222 22.552h-1.417a.66.66 0 0 1-.66-.66V19.52a.66.66 0 0 1 .66-.66h1.418"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M26.235 29.27V6.497a3.63 3.63 0 0 0-3.615-3.616c-.708 0-1.4.209-1.988.6"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M19.179 1.975a5.58 5.58 0 0 1 3.52-1.252A5.62 5.62 0 0 1 28.3 6.326v22.95"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m17.574 3.202 1.212-1.212 1.889 1.889-1.212 1.211zm.001-.004c-1.742-1.274-3.682-1.574-4.66-.596m6.976 6.976c.952-.951.762-2.786-.428-4.488"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m12.468 3.41 6.616 6.615c.1.1.26.1.36 0l.827-.826-6.977-6.977-.826.827a.256.256 0 0 0 0 .36zm3.205 3.817L14.09 8.808m-1.006 1.006-1.582 1.582m5.339-3.006-1.276 1.839m-.812 1.167-1.276 1.838m1.031-7.176L12.67 7.334m-1.168.811L9.664 9.421m2.209 10.702 10.103 6.52a.198.198 0 0 1-.122.354h-1.677c-.36 0-.71-.124-.99-.35l-7.351-4.572-7.268 4.57c-.28.227-.63.35-.99.35H1.896a.198.198 0 0 1-.122-.353zm5.642 5.5H6.25"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M10.454 17.499a1.422 1.422 0 1 1 1.42 1.43v1.198"
  }))));
};
export default SvgAccessibilityAccessibleChangingRoom;